/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { KeyFilter } from '../../../../types/KeyFilter';
import { KeySort } from '../../../../types/KeySort';

export const KeySearchRequest: core.serialization.Schema<serializers.KeySearchRequest.Raw, Truvity.KeySearchRequest> =
    core.serialization.object({
        filter: core.serialization.list(KeyFilter).optional(),
        sort: core.serialization.list(KeySort).optional(),
    });

export declare namespace KeySearchRequest {
    export interface Raw {
        filter?: KeyFilter.Raw[] | null;
        sort?: KeySort.Raw[] | null;
    }
}
